import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDown, chevronUp } from 'ionicons/icons';

export const FormSection: React.FC<{
  title: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
  action?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, collapsible, defaultOpen = true, action, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="form-section">
      <div
        className={`form-section__header${collapsible ? ' form-section__header--collapsible' : ''}`}
        onClick={collapsible ? () => setOpen(!open) : undefined}
      >
        <h3 className="form-section__title">{title}</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {action}
          {collapsible && (
            <IonIcon icon={open ? chevronUp : chevronDown} className="form-section__chevron" />
          )}
        </div>
      </div>
      {open && <div className="form-section__body">{children}</div>}
    </div>
  );
};
